import { shareOrigin } from "@/lib/origin";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

// Send a reset to a friend: a free taster page that also carries his referral code.
export async function shareReset(reset) {
  try {
    const { data } = await api.post(`/resets/${reset.id}/share`);
    const url = `${shareOrigin()}${data.path}`;
    const text = `I've been using this ${reset.title} reset from Xcelio. 90 seconds, try it:`;
    if (navigator.share) {
      await navigator.share({ title: `${reset.title} · Xcelio`, text, url });
    } else {
      await navigator.clipboard.writeText(`${text} ${url}`);
      toast("Link copied. Send it to a friend.");
    }
  } catch (e) {
    if (e?.name !== "AbortError") toast("Couldn't create the link. Please try again.");
  }
}
